import { type UseQueryResult, useQuery } from 'react-query';
import {
  TransferAllocateService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_TransferAllocate_TaTransferAllocatePropertiesDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const useGetTaTransferAllocateProperties = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_TransferAllocate_TaTransferAllocatePropertiesDto | undefined,
  unknown
> => {
  const taTransferAllocateProperties = useQuery(
    ['getTaTransferAllocateProperties', id],
    async () => {
      if (id) {
        return await handleRequest(
          TransferAllocateService.getApiAwardApiAppTransferAllocateTaTransferAllocateProperties(id)
        );
      }
    }
  );

  return taTransferAllocateProperties;
};

export default useGetTaTransferAllocateProperties;
